import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import useControlAttribute from "../../../hooks/useControlAttribute";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IComfoair350TemperatureChartProps {
  control: IControl;
  width: number;
  height: number;
}

const Comfoair350TemperatureChart = (
  props: IComfoair350TemperatureChartProps
) => {
  const { control, width, height } = props;
  const value = useControlAttribute(control, "temp_comfort");
  const { valuesList } = useControlMeasurements(control, [
    "temp_exhaust",
    "temp_outside",
    "temp_return",
    "temp_supply",
  ]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    const colorList = ["#808080", "#0000ff", "#ff0000", "#c40000"];
    chart.drawLines(ctx, valuesList, colorList, "°C");
  };

  return (
    <MeasurementChart
      title={t("Temperatures") + ` (${t("Comfort")} ${value}°C)`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default Comfoair350TemperatureChart;
